document.addEventListener("DOMContentLoaded", function () {
  //
  //
  // product forms
  const productForms = document.querySelectorAll('[id^="AddToCartForm-"]');
  //
  productForms.forEach((form) => {
    const productId = form.getAttribute("data-productid");
    const productData = window.thatWorks.productsAnywhere[productId];
    const variantButtons = form.querySelectorAll(".variant-input label");
    //
    // add disabled to any varaints that are unavailable
    variantButtons.forEach((button) => {
      // get variant id
      const variantData = productData.variants.find(
        (v) =>
          v.title ===
          button.closest(".variant-input").querySelector("input").value
      );

      // if variant unavailable, disable button
      if (!variantData.available) {
        button.closest(".variant-input").querySelector("input").disabled = true;
        button.classList.add("disabled");
      }
    });
  });

  // listen for global theme customn event for variant change and update the form field accordingly
  document.addEventListener("variant:change", (event) => {
    const variant = event.detail.variant;
    // find relvant product from data array given variant id
    const productId = Object.keys(window.thatWorks.productsAnywhere).find(
      (id) =>
        window.thatWorks.productsAnywhere[id].variants.find(
          (v) => v.id === variant.id
        )
    );

    document.querySelector(`#variant-field_${productId}`).value = variant.id;
  });

  // Modal and form handling
  const modal = document.getElementById("additional-options-modal");
  const additionalOptionsForm = document.getElementById(
    "additional-options-form"
  );
  const nationsLeaguesCheckboxes = document.querySelectorAll(
    'input[name="nations_leagues"]'
  );
  let currentForm = null;

  // Handle checkbox limit
  nationsLeaguesCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const checkedBoxes = document.querySelectorAll(
        'input[name="nations_leagues"]:checked'
      );
      if (checkedBoxes.length > 3) {
        this.checked = false;
        alert("You can only select up to 3 nations/leagues to avoid.");
      }
    });
  });

  // Handle modal close
  document.getElementById("cancel-close").addEventListener("click", () => {
    modal.classList.add("tw-hidden");
  });
  document.getElementById("cancel-options").addEventListener("click", () => {
    modal.classList.add("tw-hidden");
  });

  async function addProductToCart(form) {
  try {
    // Step 1: Clear the cart
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });

    // Step 2: Prepare form data for adding product
    const formData = new FormData(form);
    const formObject = {};
    for (let [key, value] of formData.entries()) {
      formObject[key] = value;
    }

    const cartData = {
      id: formObject.id,
      quantity: 1,
      selling_plan: formObject.selling_plan || null,
      properties: {}
    };

    Object.keys(formObject).forEach(key => {
      if (key.startsWith('properties[')) {
        const propertyName = key.replace('properties[', '').replace(']', '');
        cartData.properties[propertyName] = formObject[key];
      }
    });

    // Step 3: Add the new product
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Step 4: Go directly to checkout
    window.location.href = '/checkout';

  } catch (error) {
    console.error('Error adding to cart:', error);
    throw error;
  }
}


  // Handle form submission
  additionalOptionsForm.addEventListener("submit", (e) => {
    e.preventDefault();

    // Get selected nations/leagues
    const selectedNations = Array.from(
      document.querySelectorAll('input[name="nations_leagues"]:checked')
    ).map((cb) => cb.value);

    // Get other form values
    const specificTeams = document.getElementById("specific-teams").value;
    const additionalInfo = document.getElementById("additional-info").value;

    console.log({ selectedNations, specificTeams, additionalInfo });
    const productId = currentForm.getAttribute("data-productid");

    currentForm.querySelector(`#nations-leagues_${productId}`).value =
      selectedNations.join(", ");
    currentForm.querySelector(`#specific-teams_${productId}`).value =
      specificTeams;
    currentForm.querySelector(`#additional-info-field_${productId}`).value =
      additionalInfo;

    // Submit the original form
    // currentForm.submit();
    addProductToCart(currentForm);
  });

  // Intercept add-to-cart action to present more options in a modal
  const addToCartForms = document.querySelectorAll("form[action='/cart/add']");
  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      currentForm = form;

      // Reset form
      additionalOptionsForm.reset();

      // Show modal
      modal.classList.remove("tw-hidden");
    });
  });

  // data-section-id
  // toggle which product to show.
  const productSwitcher2 = document.querySelectorAll(`[data-toggle]`);

  productSwitcher2.forEach((button) => {
    button.addEventListener("click", () => {
      const productId = button.getAttribute("data-toggle");
      //   hide sections then show the one we want
      document.querySelectorAll(`.offer-section[data-section-id]`).forEach((section) => {
        section.classList.add("tw-hidden");
      });
      document
        .querySelector(`.offer-section[data-section-id="${productId}"]`)
        .classList.remove("tw-hidden");

      window.dispatchEvent(new Event("resize"));
    });
  });
});
